import { Section } from '@/src/containers/Landings/Section';
import { Typography } from '@/src/shared/components/Typography';

import styles from './StopWastingTimeSection.module.scss';
import FeatureItem from './FeatureItem';
import { FeaturesData } from './constants';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';

export const StopWastingTimeSection = () => {
  const isMobile = useIsMobile();

  return (
    <Section className={styles.container}>
      <Typography
        variant="heading"
        size={isMobile ? 'h5' : 'h4'}
        tag={isMobile ? 'h5' : 'h4'}
      >
        Stop Wasting Time on Content. Start Showing Up Like a Pro.
      </Typography>
      <Typography
        variant="text"
        size="xl"
        fontWeight="regular"
        className={styles.subTitle}
      >
        VuSocial helps professionals maintain a consistent social presence
        without the hassle of video production.
      </Typography>
      <div className={styles.featuresWrapper}>
        {FeaturesData.map((item, index) => {
          return <FeatureItem key={index} item={item} />;
        })}
      </div>
    </Section>
  );
};
